import { useState } from 'react'
import styled from 'styled-components'
import StepsComponent from './stepscomponent'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { adobeInteractionEvent } from 'utils/adobewa'

const TutorialTabsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1068px;
    height: 100%;
`

const TabsContainer = styled.div`
    width: 100%;
    height: 68px;
    display: flex;
    flex-direction: row;
`

interface Props {
    $selected: boolean
}

const TabItem = styled.div<Props>`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 48px;
    width: 100%;
    background-color: ${(p) => (p.$selected ? '#f6f4f1' : '#EEE9E4')};
    cursor: pointer;
`

const TabLabelText = styled.div<Props>`
    color: ${(p) => (p.$selected ? '#C5924D' : '#877')};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

export default function TutorialTabs() {
    const { t, i18n } = useTranslation('', {
        keyPrefix: 'earnwins.tutorialtabs',
    })
    const lang = i18n.language
    const configs = useSelector((state: any) => state.config.configs)
    const tabLabels = Object.keys(configs?.earnwins || [])
    const stepsLabel = tabLabels.filter(
        (tabLabel) => tabLabel !== 'en' && tabLabel !== 'zh'
    )
    const [selectedTab, setSelectedTab] = useState('engage')

    const tabOnClick = (value: string) => {
        setSelectedTab(value)
        adobeInteractionEvent({
            lang: lang,
            eventID: `prioritysite_clickTab_EarnWins_Tutorial_${value}`,
        })
    }

    return (
        <TutorialTabsContainer>
            <TabsContainer>
                {stepsLabel.map((stepLabel, index) => (
                    <TabItem
                        key={'earn-wins-step-' + index}
                        $selected={selectedTab === stepsLabel[index]}
                        onClick={() => tabOnClick(stepLabel)}
                    >
                        <TabLabelText
                            $selected={selectedTab === stepsLabel[index]}
                        >
                            {t('tab' + (index + 1))}
                        </TabLabelText>
                    </TabItem>
                ))}
            </TabsContainer>
            {configs?.earnwins ? (
                <StepsComponent
                    key={selectedTab}
                    stepItems={configs?.earnwins[selectedTab]}
                />
            ) : null}
        </TutorialTabsContainer>
    )
}
